<div class="flex flex-col justify-center items-center">
  <div class="flex flex-col items-center justify-center my-5 px-7">
    <strong class="font-black sm:text-lg text-sm">
      بازیابی رمز عبور
    </strong>

    <p class="sm:text-sm text-xs mt-2">
      برای دریافت <span class="forget-password-highlight">رمز جدید</span> ابتدا فرم زیر را تکمیل کنید
    </p>

    <p class="sm:text-sm text-xs mt-1 text-center">
      تا <span class="forget-password-highlight">احراز هویت</span> انجام شود،
    </p>

    <p class="sm:text-sm text-xs mt-1 text-center">
      سپس <span class="forget-password-highlight">رمز جدید</span> برای شما
      <span class="forget-password-highlight">پیامک</span> می‌شود.
    </p>
  </div>
</div>

<form [formGroup]="form" class="flex justify-center">
  <div class="container-inputs gap-3">
    <ng-container *ngFor="let control of formControls; let i = index">
      <div class="input-container">
        <div class="relative">
          <label [for]="control.name"></label>
          <input
            [id]="control.name"
            autocomplete="off"
            aria-label="submit-data"
            class="input-without-icon"
            formControlName="{{ control.name }}"
            [type]="control?.type ? control.type : 'text'"
            [placeholder]="control?.placeholder ? control.placeholder : ''"
          />
          <ng-container *ngFor="let icon of control?.icon">
            <span [class]="icon.placement">
              <ng-container *ngIf="icon.placement == 'right-icon'">
                <img [src]="icon.src" loading="lazy" [alt]="icon.alt" width="100px" height="70px"/>
              </ng-container>
            </span>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="session == 1">
      <div class="col-span-2 text-center">
        <p class="text-sm font-normal inline-block">
          کد تائید به شماره {{ form.controls["phoneNumber"].value }} ارسال شد
        </p>
        <img loading="lazy" src="assets/icon/pencil.svg" class="inline-block" alt="pencil" width="50px" height="20px"/>
      </div>
      <div class="px-2 col-span-2 flex max-w-full justify-center items-center">
        <ng-otp-input
          dir="ltr"
          (onInputChange)="onOtpChange($event)"
          [config]="otpConfig"
        ></ng-otp-input>
      </div>
    </ng-container>
    <button
      type="button"
      aria-label="برگشت به لاگین"
      name="getBackToLogin"
      [disabled]="loading || (session == 1 && !codeValidation)"
      (click)="sendReq(session)"
      class="relative button-submit rounded-lg text-white font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 col-span-2"
    >
      {{ btnText }}
    </button>
    <p class="col-span-2 text-sm text-center">
      <button
        type="button"
        aria-label="برگشت به ورود"
        name="getBackToLogin"
        [disabled]="loading"
        class="text-blue-800 p-0 m-0 bg-transparent cursor-pointer font-black"
        (click)="getBackToLogin()"
      >
        بازگشت به ورود
      </button>
    </p>
  </div>
</form>
<!-- <ng-container *ngIf="icon.placement == 'left-icon'">
                <img
                  (click)="showPassClick(icon, i)"
                  [@rotatedState]="state"
                  [src]="icon.src"
                  [alt]="icon.alt"
                />
              </ng-container> -->
